import {
  ClientGroupMemberAccessTypes,
  OrganizationUserAccessTypes,
} from '@generated/graphql';
import type { ClientGroup } from '@interfaces/clientGroup';
import type { Relationship } from '@interfaces/relationship';
import type { IUserEntity } from '../ovComponents/3-pattern/viewAllProfilesDialog/viewAllProfilesDialog.types';

const filterHouseholdsWithAccess = (
  households: ClientGroup[],
  userId?: string,
  userContext?: {
    accessType?: OrganizationUserAccessTypes;
    entities?: IUserEntity[];
  },
) =>
  households.filter((household: ClientGroup) =>
    household.relationships.some(
      (rel: Relationship) =>
        rel.user.id === userId &&
        rel.accessType !== ClientGroupMemberAccessTypes.NoAccess &&
        // If the user/entity has only limited poa access, then the household should not be shown
        (userContext?.accessType === OrganizationUserAccessTypes.Entity
          ? userContext?.entities?.some(
              (en) => en.entity.id === userId && en.accounts.length === 0,
            )
          : true),
    ),
  );

export default filterHouseholdsWithAccess;
